
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrepreneurs",
      function () {
        return require("private-next-pages/entrepreneurs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/entrepreneurs"])
      });
    }
  